import customAxios from "./customAxios";
import normalize from "json-api-normalizer"

export const deleteScheduledAssignmentGroup = (baseUrl, surveyorAssignmentId) => {
    const path = `${baseUrl}/surveyor_assignments/${surveyorAssignmentId}`
    return customAxios.delete(path)
        .then(({ data, status }) => ({ response: normalize(data), status }))
        .catch(error => ({ error }))
}

export const updateSurveyorAssignmentOperationValue = (baseUrl, assignmentId, params) => {
    const path = `${baseUrl}/surveyor_assignments/${assignmentId}`
    return customAxios.patch(path, params)
        .then(({ data, status }) => ({ response: normalize(data), status }))
        .catch(error => ({ error }))
}
